import React from 'react';
import { Handle } from 'reactflow';
import { PiTreeStructureDuotone } from 'react-icons/pi';
const DataSplitterNode = ({ id, data }) => {
  return (
    <div className="w-72 rounded-lg border bg-zinc-800 text-zinc-100 shadow-md">
      <div className="flex items-center gap-2 border-b border-zinc-700 px-4 py-2">
        <PiTreeStructureDuotone className="rotate-90 text-2xl" />
        <p className="text-md font-semibold">Data Splitter</p>
      </div>
      <p className="flex flex-col border-b border-zinc-700 px-4 py-2 text-sm ">
        <span className="mb-1 w-full text-left text-xs font-medium text-zinc-400">
          Purpose:
        </span>{' '}
        <span className="max-w-full overflow-hidden text-left text-xs">
          {data.purpose.length > 60
            ? `${data.purpose.slice(0, 60)}...`
            : data.purpose}
        </span>
      </p>

      <div className="px-4 py-2 text-xs">
        <span className="mb-1 w-full text-left text-xs font-medium text-zinc-400">
          Levels:
        </span>{' '}
        <ul className="list-disc pl-4">
          {data.levels &&
            data.levels.map((level, index) => (
              <li key={level.id}>
                <strong>Level {index}:</strong>{' '}
                {level.description || 'No description'}
              </li>
            ))}
        </ul>
      </div>
      <Handle
        type="target"
        position="left"
        className="border-none bg-yellow-400"
        style={{
          left: '-6px',
          top: '50%',
          transform: 'translateY(-50%)',
          height: '10px',
          width: '10px',
        }}
      />
      <Handle
        type="source"
        position="right"
        className="border-none bg-blue-400"
        style={{
          right: '-6px',
          top: '50%',
          transform: 'translateY(-50%)',
          height: '10px',
          width: '10px',
        }}
      />
    </div>
  );
};

export default DataSplitterNode;
